<template>
    <Modal
      :title="modalTitle"
      v-model="confirmationModalOpen"
      :handleClose="modalCancelHandler"
    >
      <p class="text-md font-semibold">{{ modalQuestion }}</p>
      <div class="flex items-center justify-end pt-6">
        <button
          type="button"
          v-if="isCancellable"
          class="inline-flex items-center h-10 px-4 m-2 text-green-light transition-colors duration-150 ring-green-light rounded-lg focus:outline-none hover:bg-green-light hover:text-white ring-1"
          @click="localModalCancelHandler"
        >
          {{modalCancelText || 'Cancel'}}
        </button>
        <button
          type="submit"
          class="h-10 px-4 m-2 text-sm text-white transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline"
          @click.prevent="confirmModalHandler"
        >
          {{ modalConfirmText || 'Confirm' }}
        </button>
      </div>
    </Modal>
</template>
<script>
import Modal from "@/components/t-components/Modal.vue";
import * as Cookies from 'js-cookie'
export default {
  name: "ConfirmationsModal",
  components: {
    Modal
  },
  props: [
    'modalTitle',
    'modalQuestion',
    'confirmationModalOpen',
    'modalCancelHandler',
    'confirmModalHandler',
    'isCancellable',
    'modalCancelText',
    'modalConfirmText',
    'maintainCancelCookie'
  ],
  methods: {
    cookieFlagHandler (cookieName) {
      const expirationDate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000) // Expires in 1 day
      Cookies.set(cookieName, 'hidden', {
        expires: expirationDate,
        secure: true
      })
    },
    localModalCancelHandler () {
        if (this.maintainCancelCookie) {
          this.cookieFlagHandler(this.maintainCancelCookie)
        }
        this.modalCancelHandler()
    }
  }
}
</script>